(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.site-header').forEach((header)=>{const button=header.querySelector('.menu-toggle');const menu=header.querySelector('.mobile-nav');button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));menu.hidden=open;});});

  } catch(e) { console.error(e); }
})();
})();
